import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  DeleteDataOnServer,
  GetDataListFromServer,
  UpdatebankDataOnServer,
} from "../../lib/api";
import {
  AGENT_BANK_ACTIVATE,
  AGENT_BANK_DEACTIVATE,
  AGENT_BANK_DELETE,
  AGENT_BANK_LIST,
} from "../../lib/config";
import { QUERY_AGENT_BANK } from "../../lib/query_obj";
import { queryHandler } from "../../lib/global_functions";
import {
  Button,
  Col,
  Drawer,
  message,
  Popconfirm,
  Row,
  Space,
  Table,
  Tag,
  Typography,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";
import AgentBankForm from "./form";

const { Text } = Typography;
export default function AgentBank() {
  const { access_token, csrf_token, permissions, ui_size } = useSelector(
    (state) => state.user
  );

  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [showForm, setShowForm] = useState(false);

  const [pagin, setPagin] = useState({
    page_number: 1,
    per_page: 10,
    total: 0,
  });
  const [filter, setFilter] = useState({
    name: "",
    order_by: "created_at",
    order_type: "DESC",
  });

  async function getDataList(page_number, per_page) {
    setLoading(true);
    await GetDataListFromServer(
      AGENT_BANK_LIST,
      queryHandler(filter, QUERY_AGENT_BANK, { page_number, per_page }),
      access_token
    )
      .then(({ data: { data: res, total } }) => {
        setLoading(false);
        setPagin((prev) => ({ ...prev, page_number, per_page, total }));
        setList(Array.isArray(res) ? res : []);
      })
      .catch((error) => {
        setLoading(false);
        message.error(error?.response?.data?.error || "Connection Error");
      });
  }

  useEffect(() => {
    getDataList(pagin.page_number, pagin.per_page);
  }, []);

  const columns = [
    {
      title: "Name",
      dataIndex: "acc_name",
    },
    {
      title: "Bank Type",
      dataIndex: "bank_type",
      render: (record) => {
        return renderBankOption(record);
      },
    },
    {
      title: "Account No.",
      dataIndex: "acc_number",
    },
    {
      title: "Is Active?",
      dataIndex: "is_active",
      render: (record) => (
        <Tag color={record ? "lime" : "red"}>
          <Text style={{ color: record ? "lime" : "red" }}>
            {record ? "Yes" : "No"}
          </Text>
        </Tag>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      width: "150px",
      render: (_, record) => (
        <Row justify="end">
          <Space>
            {permissions.includes("AGENT_UPDATE_BANK_ACCOUNT") && (
              <Popconfirm
                title={`Are you sure to ${
                  record.is_active ? "deactivate" : "activate"
                } this bank?`}
                okText="Yes"
                cancelText="No"
                onConfirm={() =>
                  toggleActiveHandler(record.id, record.is_active)
                }
              >
                <Button size={ui_size} type="primary" danger={record.is_active}>
                  {record.is_active ? "Deactivate" : "activate"}
                </Button>
              </Popconfirm>
            )}
            {permissions.includes("AGENT_DELETE_BANK_ACCOUNT") && (
              <Popconfirm
                title="Are you sure to delete?"
                onConfirm={() => deleteHandler(record.id)}
                okText="Yes"
                cancelText="No"
              >
                <Button size={ui_size} type="primary" danger>
                  Delete
                </Button>
              </Popconfirm>
            )}
          </Space>
        </Row>
      ),
    },
  ];
  const openDrawer = () => setShowForm(true);

  function closeDrawer(key) {
    setShowForm(false);
    if (key) {
      getDataList(pagin.page_number, pagin.per_page);
    }
  }

  async function deleteHandler(id) {
    setLoading(true);

    await DeleteDataOnServer(AGENT_BANK_DELETE, id, access_token, csrf_token)
      .then(() => {
        setLoading(false);
        toast.success("Deleted bank account successfully");
        getDataList(pagin.page_number, pagin.per_page);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Delete failed");
      });
  }

  async function toggleActiveHandler(id, active) {
    setLoading(true);

    const endpoint = active ? AGENT_BANK_DEACTIVATE : AGENT_BANK_ACTIVATE;
    const successMessage = active ? "Deactivated" : "Activated";

    await UpdatebankDataOnServer(endpoint, id, access_token, csrf_token)
      .then(() => {
        setLoading(false);
        toast.success(`${successMessage} bank successfully`);
        getDataList(pagin.page_number, pagin.per_page);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.message || "Connection Error");
      });
  }

  const BANK_ICON_MAP = {
    KBZ_PAY: "/assets/kbz pay.svg",
    WAVE_PAY: "/assets/wave pay.svg",
    AYA_PAY: "/assets/aya pay.svg",
    CB_PAY: "/assets/cb pay.svg",
    CB_BANK: "/assets/cb bank.svg",
    AYA_BANK: "/assets/aya bank.svg",
    KBZ_BANK: "/assets/kbz bank.svg",
  };
  function renderBankOption(value) {
    const iconPath = BANK_ICON_MAP[value];
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img src={iconPath} alt={value} style={{ width: 30, height: 30, borderRadius:"5px" }} />
      </div>
    );
  }

  return (
    <>
      <Row gutter={[0, 16]} justify={"end"}>
        <Col>
          {permissions.includes("AGENT_CREATE_BANK_ACCOUNT") && (
            <Button
              size={ui_size}
              type="primary"
              onClick={openDrawer}
              icon={<PlusOutlined />}
            >
              New Bank Account
            </Button>
          )}
        </Col>
        <Col span={24}>
          <Table
            size={ui_size}
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={list}
            loading={loading}
            pagination={{
              total: pagin.total,
              defaultCurrent: 1,
              defaultPageSize: 10,
              showSizeChanger: true,
              pageSizeOptions: [10, 20, 50],
              onChange: (pageNumber, perPage) => {
                getDataList(pageNumber, perPage);
              },
            }}
          />
        </Col>
      </Row>
      <Drawer
        open={showForm}
        title="Create Bank Account Form"
        onClose={() => setShowForm(false)}
        destroyOnClose
        placement="right"
        width={"500px"}
      >
        <AgentBankForm closeDrawer={closeDrawer} />
      </Drawer>
    </>
  );
}
